const STAGE_EASING = 'cubic-bezier(0.32, 0.72, 0, 1)';
const STAGE_DEFAULT_DURATION = 420;

class AcneStageAccordion extends HTMLElement {
  connectedCallback() {
    this.animations = new WeakMap();
    this.handleClick = this.handleClick.bind(this);
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  get duration() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return 0;
    return Number(this.dataset.duration) || STAGE_DEFAULT_DURATION;
  }

  handleClick(event) {
    const summary = event.target.closest('summary');
    if (!summary || !this.contains(summary)) return;

    const details = summary.parentElement;
    if (details?.tagName !== 'DETAILS') return;

    event.preventDefault();

    if (details.open) {
      this.collapse(details);
    } else {
      this.expand(details);
    }
  }

  expand(details) {
    for (const open of this.querySelectorAll('details[open]')) {
      if (open !== details) this.collapse(open);
    }

    const panel = details.querySelector('[data-stage-panel]');
    if (!panel) {
      details.open = true;
      return;
    }

    // Measure before flipping `open` so a reversed collapse resumes mid-flight.
    const from = this.currentHeight(details, panel);
    details.open = true;
    this.run(details, panel, from, panel.scrollHeight);
  }

  collapse(details) {
    const panel = details.querySelector('[data-stage-panel]');
    if (!panel) {
      details.open = false;
      return;
    }

    const animation = this.run(details, panel, this.currentHeight(details, panel), 0);
    animation.addEventListener('finish', () => {
      details.open = false;
    });
  }

  currentHeight(details, panel) {
    return details.open ? panel.getBoundingClientRect().height : 0;
  }

  run(details, panel, from, to) {
    this.animations.get(details)?.cancel();

    const animation = panel.animate(
      {
        height: [`${from}px`, `${to}px`],
        opacity: [from === 0 ? 0 : 1, to === 0 ? 0 : 1],
      },
      { duration: this.duration, easing: STAGE_EASING },
    );

    this.animations.set(details, animation);
    return animation;
  }
}

if (!customElements.get('acne-stage-accordion')) {
  customElements.define('acne-stage-accordion', AcneStageAccordion);
}
